import { render, staticRenderFns } from "./ListView.vue?vue&type=template&id=2274f99a&scoped=true"
import script from "./ListView.vue?vue&type=script&lang=js"
export * from "./ListView.vue?vue&type=script&lang=js"
import style0 from "./ListView.vue?vue&type=style&index=0&id=2274f99a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2274f99a",
  null
  
)

export default component.exports